interface MediaQueryOptions {
  maxWidth?: string;
  minWidth?: string;
}

const getMediaQueryString = (maxWidth?: string, minWidth?: string): string | null => {
  const maxWidthQuery = maxWidth ? `(max-width: ${maxWidth})` : '';
  const minWidthQuery = minWidth ? `(min-width: ${minWidth})` : '';

  if (maxWidthQuery && minWidthQuery) {
    // Comma-separated media queries are evaluated as OR, which matches the previous behavior callers relied on.
    return `${minWidthQuery}, ${maxWidthQuery}`;
  }

  return maxWidthQuery || minWidthQuery || null;
};

export function useMediaQuery({ maxWidth, minWidth }: MediaQueryOptions): boolean | null {
  const mediaQueryString = getMediaQueryString(maxWidth, minWidth);

  if (!mediaQueryString || globalThis.window === undefined) {
    return null;
  }

  return globalThis.window.matchMedia(mediaQueryString).matches;
}
